import {DriverTrophyModel, SeasonResultModel} from "../../features/profile/profileTypes";

type Props = {
    results: SeasonResultModel | null,
    trophy: DriverTrophyModel | null
};

const RankItem = ({results, trophy}: Props) => {
    return (
        <h3 className='mb-0'>
            <span className='badge badge-lg rounded-pill bg-main-darker'>
                {results && trophy &&
                    <span>
                        <i className={`trophy-icon ${trophy.name}`}></i> / {results.points}
                    </span>
                }

                {results && !trophy &&
                    <span className='font-weight-bold'>#{results.rank} / {results.points}</span>
                }

                {!results &&
                    <span className='font-weight-bold text-danger'>NQ</span>
                }
            </span>
        </h3>
    )
}

const podiumIcon = {
    color: 'red',
    background: 'blue'
}

export default RankItem;
